export default __webpack_public_path__ + "static/media/bonus.0d7a543a.png";